// extracted by mini-css-extract-plugin
module.exports = {"contactCard":"contactcard-module--contactCard--3Tsgz","linkTitle":"contactcard-module--linkTitle--3Dhhl","linkDescription":"contactcard-module--linkDescription--1UyDr"};